import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=2ffe146e&scoped=true&"
import script from "./UserLogs.vue?vue&type=script&lang=js&"
export * from "./UserLogs.vue?vue&type=script&lang=js&"
import style0 from "./UserLogs.vue?vue&type=style&index=0&id=2ffe146e&scoped=true&lang=scss&"
import style1 from "./UserLogs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe146e",
  null
  
)

export default component.exports